export const normalizeSupportPersonKey = (nickname: string): string =>
  nickname.trim().toLowerCase()
